<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h3>APS Intake</h3></app-anchor
	>
	<h3 class="flex-1">/ Edit</h3>
</div>

<app-container type="dark" *ngIf="client$ | async as client">
	<app-edit-business-client-side-form
		*ngIf="client?.type !== clientTypes.PERSON"
		[client]="client"
		[primaryContact]="clientMatterRelationship?.primaryContact"
		[showPrimaryClientOption]="clientMatterRelationship?.client"
	>
	</app-edit-business-client-side-form>

	<app-edit-person-client-side-form
		*ngIf="client?.type === clientTypes.PERSON"
		[client]="client"
		[primaryContact]="clientMatterRelationship?.primaryContact"
		[showPrimaryClientOption]="clientMatterRelationship?.client"
	>
	</app-edit-person-client-side-form>
</app-container>
